<div class="flex-row ti">
    <span>
        <ng-content>
        </ng-content>
        {{label}}
    </span>
    <span>
        @for (icon of icons; track icon.id) {
            @if (icon.badgeCount != null) {
                <p-badge [value]="icon.badgeCount"></p-badge>
            }
            @else {
                <span [class]="(icon.icon != null ? icon.icon : '') + ' ' + (icon.styleClass != '' ? icon.styleClass : '') + ' mr-1'" [class.mouse-pointer]="icon.clickable" [class.only-hover]="icon.onlyOnHover" (click)="click(icon)"></span>
            }
        }
    </span>
</div>
